// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1827":"d803a177","2540":"5d199834","5577":"97c3bb4b","6325":"59231db0","6365":"97c3bb4b"}[chunkId] + ".chunk.css";
};